import { TemplateRef } from '@angular/core';
import { TabViewChangeEvent, TabViewCloseEvent } from 'primeng/tabview';

export interface IEoTabConfig {
  title: string;
  content?: TemplateRef<any> | null;
  disabled?: boolean;
  closable?: boolean;
  selected?: boolean;
  styleClass?: string;
  headerStyleClass?: string;
  leftIcon?: string;
  rightIcon?: string;
  tooltip?: string;
  tooltipPosition?: 'top' | 'bottom' | 'left' | 'right';
  tooltipPositionStyle?: string;
  tooltipStyleClass?: string;
  enterActiveClass?: string;
  leaveActiveClass?: string;
}

export class EoTabConfig implements IEoTabConfig {
  title: string;
  content?: TemplateRef<any> | null;
  disabled?: boolean;
  closable?: boolean;
  selected?: boolean;
  styleClass?: string;
  headerStyleClass?: string;
  leftIcon?: string;
  rightIcon?: string;
  tooltip?: string;
  tooltipPosition?: 'top' | 'bottom' | 'left' | 'right';
  tooltipPositionStyle?: string;
  tooltipStyleClass?: string;
  enterActiveClass?: string;
  leaveActiveClass?: string;

  constructor();
  constructor(obj: IEoTabConfig);
  constructor(obj?: IEoTabConfig) {
    this.title = obj?.title ?? '';
    this.content = obj?.content ?? null;
    this.disabled = obj?.disabled ?? false;
    this.closable = obj?.closable ?? false;
    this.selected = obj?.selected ?? false;
    this.styleClass = obj?.styleClass ?? '';
    this.headerStyleClass = obj?.headerStyleClass ?? '';
    this.leftIcon = obj?.leftIcon ?? '';
    this.rightIcon = obj?.rightIcon ?? '';
    this.tooltip = obj?.tooltip ?? '';
    this.tooltipPosition = obj?.tooltipPosition ?? 'bottom';
    this.tooltipPositionStyle = obj?.tooltipPositionStyle ?? '';
    this.tooltipStyleClass = obj?.tooltipStyleClass ?? '';
    this.enterActiveClass = obj?.enterActiveClass ?? '';
    this.leaveActiveClass = obj?.leaveActiveClass ?? '';
  }
}

export interface IEoTabsConfig {
  tabs: IEoTabConfig[];
  styleClass?: string;
  controlClose?: boolean;
  scrollable?: boolean;
  activeIndex?: number | null;
  selectOnFocus?: boolean;
  nextButtonAriaLabel?: string;
  prevButtonAriaLabel?: string;
  autoHideButtons?: boolean;
  tabindex?: number;
  onChange?: (event: TabViewChangeEvent) => void;
  onClose?: (event: TabViewCloseEvent) => void;
  activeIndexChange?: (event: number) => void;
}

export class EoTabsConfig implements IEoTabsConfig {
  tabs: IEoTabConfig[];
  styleClass?: string;
  controlClose?: boolean;
  scrollable?: boolean;
  activeIndex?: number | null;
  selectOnFocus?: boolean;
  nextButtonAriaLabel?: string;
  prevButtonAriaLabel?: string;
  autoHideButtons?: boolean;
  tabindex?: number;
  onChange?: (event: TabViewChangeEvent) => void;
  onClose?: (event: TabViewCloseEvent) => void;
  activeIndexChange?: (event: number) => void;

  constructor();
  constructor(obj: IEoTabsConfig);
  constructor(obj?: IEoTabsConfig) {
    this.tabs = obj?.tabs ?? [];
    this.styleClass = obj?.styleClass ?? '';
    this.controlClose = obj?.controlClose ?? false;
    this.scrollable = obj?.scrollable ?? false;
    this.activeIndex = obj?.activeIndex ?? null;
    this.selectOnFocus = obj?.selectOnFocus ?? false;
    this.nextButtonAriaLabel = obj?.nextButtonAriaLabel ?? 'Επόμενο';
    this.prevButtonAriaLabel = obj?.prevButtonAriaLabel ?? 'Προηγούμενο';
    this.autoHideButtons = obj?.autoHideButtons ?? true;
    this.tabindex = obj?.tabindex ?? 0;
    this.onChange = obj?.onChange;
    this.onClose = obj?.onClose;
    this.activeIndexChange = obj?.activeIndexChange;
  }
}
